import { Typography } from "@mui/material";

type Props = {
  title: string;
};

export const ListTitle = ({ title }: Props) => (
  <Typography
    sx={{
      fontWeight: 600,
      fontSize: 16,
      marginBottom: 1,
    }}
  >
    {title}
  </Typography>
);
